import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

//Components
import TextField from '../../../components/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';

//Api
import tipoRequerimento_api from '../../../api/tipoRequerimento_api';
import requerimentoPodas_api from '../../../api/requerimentoPodas_api';

//Context
import { useAuth } from '../../../context/auth';
import { showMessage } from '../../../helpers/message';

//Helpers
import mascaras from '../../../helpers/mascaras';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial dos filtros
function initialStateFiltros() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);
    return {
        tipoRequerimento_Id: null,
        numeroRequerimento: null,
        cpfRequerente: null,
        dataInicial: "",
        dataFinal: "",
        situacao: "",
    };
}

//Estado inicial dos campos obrigatorios
function initialStateCampos() {
    return [
        objCampo({ name: "dataInicial", required: false }),
        objCampo({ name: "dataFinal", required: false }),
        objCampo({ name: "situacao", required: false }),
    ];
}

//Estado inicial da poda a ser realizada
function initialStatePoda(id = "") {
    return {
        id: id,
        requerimentoEspecie_Id: 1,
        status: "",
        DataExecucao: "",
        usuario_Id: "",
        observacoes: "",
        imagem: "",
    }
}

export default function ConfirmacaoDePoda() {
    const { setLoading } = useAuth();

    //Estado de controle dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);

    //Função de troca do estado de visibilidade do modal
    const toggleModal = () => {
        setVisibleModal(!visibleModal);
    }

    //Campos obrigatorios
    const [campos, setCampos] = useState(initialStateCampos);

    //Estado de controle de erros nos campos
    const [errors, setErrors] = useState({});

    //Estado de controle da lista de podas
    const [podas, setPodas] = useState([]);

    //Estado de controle dos dados da poda
    const [poda, setPoda] = useState(initialStatePoda(""));

    //Estado de controle das opções dos tipos de requerimento
    const [tiposRequerimento, setTiposRequerimento] = useState([]);

    //Estado de controle de visibilidade dos filtros
    const [visibleFilters, setVisibleFilters] = useState(true);

    //Função de onChange para os campos normais dos filtros
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //onChange para o campo pesquisavel
    const onChangeSearchable = (e, field) => {
        setFiltros({
            ...filtros,
            [field.name]: e != null ? e.value : null
        })
    }

    //onChange para o campo de observações
    const onChangeObservacoes = (e) => {
        const { name, value } = e.target;
        setPoda({
            ...poda,
            [name]: value
        })
    }

    //Função de onChange do arquivo de anexo
    const onChangeAnexo = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            const base64 = evt.target.result;
            setPoda({
                ...poda,
                imagem: base64
            });
        });

        FR.readAsDataURL(e.target.files[0]);
    }

    //Estado de troca da visibilidade dos filtros
    const toggleFilters = () => {
        setVisibleFilters(!visibleFilters);
    }

    //Função que carrega a lista de arvores que precisam confirmar poda
    const loadPodas = () => {
        let camposObrigatoriosIsolados = [];
        if (!!filtros.cpfRequerente) {
            camposObrigatoriosIsolados.push(objCampo({ name: "cpfRequerente", required: true, cpf: true }));
        }
        if (!!filtros.numeroRequerimento) {
            camposObrigatoriosIsolados.push(objCampo({ name: "numeroRequerimento", required: true }));
        }
        const _errors = validarCampos(filtros, camposObrigatoriosIsolados.length > 0 ? camposObrigatoriosIsolados : campos);
        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        setLoading(true);
        requerimentoPodas_api.getList(filtros).then(response => {
            response.data = response.data.map(value => {
                value.data = moment(value.data).format("DD/MM/YYYY");
                return value;
            });
            setPodas(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função de confirmação de poda
    const confirmarPoda = (value) => {
        setPoda(initialStatePoda(value.requerimentoEspeciePoda_Id))
        toggleModal();
    }
    const visualizarPoda = (value) => {
        setPoda(value);
        toggleModal();
    }
    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Requerimento", objectValue: "requerimento", align: "left" },
        { value: "Data", objectValue: "data", align: "left" },
        { value: "Nome Requerente", objectValue: "nomeRequerente", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        { value: "Situação da poda", objectValue: "situacaoPoda", align: "left" },
    ]


    //Ações da tabela
    const actions = [
        (rowData) => {
            if (rowData.situacaoPoda == "Pendente")
                return actionsTable.confirmar(confirmarPoda);
            else
                return actionsTable.visualizar(visualizarPoda);
        }
    ]

    //Função que carrega os tipos de requerimento disponiveis
    const loadRequerimentos = () => {
        setLoading(true);
        tipoRequerimento_api.getList().then(response => {
            response.data = response.data.filter(value => value.status == "Ativo").map(value => ({ value: value.id, label: value.identificacao }))
            setTiposRequerimento(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função de submit dos dados da poda
    const onSubmitPoda = (status) => {
        const _poda = { ...poda };
        _poda.status = status;

        setErrors({
            ...!_poda.imagem ? { imagem: true } : {},
            ...!_poda.observacoes ? { observacoes: true } : {},
        })
        if (!_poda.imagem || !_poda.observacoes) {
            return;
        }

        setLoading(true);
        requerimentoPodas_api.update(_poda).then(response => {
            showMessage("Sucesso!", "Sucesso ao atualizar poda!", "success", toggleModal);
            loadPodas();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null)
        })
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadRequerimentos();
    }, []);

    return (
        <div>
            <ModalCustomized className={!poda.situacaoPoda ? "" : "modalMenor"} title={!poda.situacaoPoda ? "Confirmar poda" : "Detalhes"} isOpen={visibleModal} toggle={toggleModal} btnClose={true}>
                {
                    !poda.situacaoPoda ?
                        <Row>
                            <Col md="12">
                                <TextField label={"* Observaçãos"} type={"textarea"} name={"observacoes"} value={poda.observacoes} onChange={onChangeObservacoes} invalid={errors.observacoes} />
                            </Col>
                            <Col md="12">
                                <TextField label={"* Imagem"} type={"file"} onChange={onChangeAnexo} invalid={errors.imagem} />
                            </Col>
                            <Col md="12" className='d-flex align-items-center justify-content-center'>
                                <Button className='me-5' color='success' onClick={() => onSubmitPoda("Executado")}>Confirmar poda</Button>
                                <Button color='danger' onClick={() => onSubmitPoda("Cancelado")}>Cancelar poda</Button>
                            </Col>
                        </Row>
                        :
                        <Row>
                            <Col md="12" className='d-flex align-items-center justify-content-center'>
                                <div className='rounded rounded-3 overflow-hidden'>
                                    <img src={poda.imagem} width={250} />
                                </div>
                            </Col>
                            <Col md="12" className='d-flex align-items-center justify-content-center mt-3 text-secondary'>
                                <p><span className="fw-bold">Observações: </span>{poda.observacoes}</p>

                            </Col>
                            <Col md="12" className='d-flex align-items-center justify-content-center mt-3 text-secondary'>
                                <p><span className="fw-bold">Data de execução: </span>{moment(poda.dataExecucao).format("DD/MM/YYYY")}</p>

                            </Col>
                        </Row>
                }
            </ModalCustomized>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Confirmação de poda</h4>
                <Button color='primary' onClick={toggleFilters}><FontAwesomeIcon icon={faFilter} /> Filtros</Button>
            </div >
            <Row className={`filtros ${visibleFilters ? "" : "close"}`}>
                <Col md="12" lg="6">
                    <TextField
                        label={"Tipo de Requerimento"}
                        type={"select"}
                        searchable
                        name={'tipoRequerimento_Id'}
                        options={tiposRequerimento}
                        value={tiposRequerimento.filter(value => value.value == filtros.tipoRequerimento_Id)}
                        onChange={onChangeSearchable}
                    />
                </Col>
                <Col md="12" lg="3">
                    <TextField
                        label={`${!!filtros.numeroRequerimento ? "*" : ""} Número do Requerimento`}
                        name={"numeroRequerimento"}
                        value={filtros.numeroRequerimento}
                        onChange={onChangeFiltros}
                    />
                </Col>
                <Col md="12" lg="3">
                    <TextField
                        label={`${!!filtros.cpfRequerente ? "*" : ""} CPF do Requerente`}
                        name={"cpfRequerente"}
                        value={filtros.cpfRequerente}
                        mask={mascaras.cpfMask}
                        onChange={onChangeFiltros}
                        invalid={errors.cpfRequerente}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={`${!!filtros.cpfRequerente || !!filtros.numeroRequerimento ? "" : "*"} Data Inicial`}
                        name={"dataInicial"}
                        value={filtros.dataInicial}
                        type={"date"}
                        onChange={onChangeFiltros}
                        invalid={errors.dataInicial}
                        maxLength={14}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={`${!!filtros.cpfRequerente || !!filtros.numeroRequerimento ? "" : "*"} Data Final`}
                        name={"dataFinal"}
                        value={filtros.dataFinal}
                        type={"date"}
                        onChange={onChangeFiltros}
                        invalid={errors.dataFinal}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={`${!!filtros.cpfRequerente || !!filtros.numeroRequerimento ? "" : "*"} Situação`}
                        name={"situacao"}
                        type={"select"}
                        value={filtros.situacao}
                        options={[
                            { label: "Selecione", value: "" },
                            { label: "Pendente", value: "Pendente" },
                            { label: "Executado", value: "Executado" },
                            { label: "Cancelado", value: "Cancelado" },
                        ]}
                        onChange={onChangeFiltros}
                        invalid={errors.situacao}
                    />
                </Col>
                <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mb-4'>
                    <Button color='primary' onClick={loadPodas}><FontAwesomeIcon icon={faFilter} /> Filtrar</Button>
                </Col>
            </Row>
            <TabelaListagem headers={headers} items={podas} actions={actions} />
        </div>
    )
}